import React, { Component, useEffect, useRef } from 'react';

// partner integrations new in this release: NEW mark on the card and the sidebar entry
const NEW_PARTNER_SLUGS = ['size_chart_avada'];
import withStyles from '../../withStylesAdapter';
import { useTheme } from '@mui/material/styles';
import classNames from 'classnames';
import withRouter from 'with-router';
import { bindActionCreators } from 'redux'
import { connect, useSelector, useDispatch } from 'react-redux';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import NewBadge from '../../components/NewBadge';
import Collapse from '@mui/material/Collapse';
import { List, ListItem, ListItemText } from '@mui/material';
import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import { useSnackbar } from 'notistack';

import PartnerIntegrationsSettings, { PAID_PARTNER_SLUGS } from '../../components/PartnerIntegrations';
import { UpgradePlanHint } from '../../components/PricingPlans';
import LoadingIndicator from '../../components/LoadingIndicator';
import appIntegrations, { loadPartners } from '../../modules/appIntegrations';
import { NavigationLink } from '../app/Navigation';

class AppIntegrations extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    if (this.props.partners.length === 0) {
      this.props.loadPartners();
    }
  }


  // the whole banner (blurred artwork and logo) links to the app's listing: the "Get the App"
  // button goes once an integration is enabled, and the switch no longer sits up there, so a
  // click cannot go wrong
  linkToListing = (item, children) => {
    if(!item.storeLink) return children;
    return (
      <a href={item.storeLink} target="_blank" rel="noopener noreferrer" title={this.props.t('partnerIntegrations.openListingTitle')} style={{ display: 'block', cursor: 'pointer' }}>
        {children}
      </a>
    );
  }

  renderLogo = (item, className) => (
    <span className={className} style={{ backgroundImage: `url(/files/images/recommendedApps/${item.logo})` }} />
  )

  renderPartnerCard = (item, index, activeIntegartions) => {
    const { classes, t } = this.props;

    return (
      <Card key={`card-${item.title}`} className={classes.cardRoot}>
        {this.linkToListing(item,
          <div className={classes.banner}>
            <div className={classes.media}>
              <img
                src={'/files/images/recommendedApps/' + item.logo.replace('.jpg', '_b.jpg')}
                alt={item.title}
              />
              <div className={classes.diffusor}></div>
            </div>
            {this.renderLogo(item, classes.mediaLogo)}
          </div>
        )}
        <CardContent className={classes.cardContent}>
          <Typography gutterBottom variant="h5" component="h4" align="center">
            {item.title}
            {NEW_PARTNER_SLUGS.includes(item.slug) && <NewBadge sx={{ ml: 1, verticalAlign: 'middle' }} />}
          </Typography>
          {item.subtitle && (
            <Typography
              gutterBottom
              variant="caption"
              component="p"
              align="center"
              style={{ marginBottom: 12 }}
            >
              <Chip label={item.subtitle} size="small" variant="outlined" />
            </Typography>
          )}
          <Typography variant="body2" color="text.secondary" component="p">
            {item.description}
          </Typography>
        </CardContent>
        <PartnerIntegrationsSettings
          partnerHandle={item.slug}
          partnerData={item}
          activeIntegration={activeIntegartions.find((x) => x.slug === item.slug)}
          partnerIntegration={item.partnerIntegration.integration}
        />
        <CardActions className={classes.cardActions}>
          {/* External apps (no modules) */}
          {item.storeLink && !activeIntegartions.find((x) => x.slug === item.slug) && (
            <Button size="small" color="primary" variant="contained" href={item.storeLink} target="_blank" fullWidth>
              {t('partnerIntegrations.getAppBtn')}
            </Button>
          )}
          {/* same condition as the sidebar entry in IntegratedAppsList, so the button appears exactly
              when there is a page to reach (api key apps like Sitemapper store no enabled flag) */}
          {item.partnerIntegration.integration?.data?.enabled === true && (
            this.props.shopPlan === 'free' && PAID_PARTNER_SLUGS.includes(item.slug) ?
              <div style={{ position: 'relative', width: '100%' }}>
                <Button size="small" color="primary" variant="contained" disabled fullWidth>
                  {t('partnerIntegrations.goToAppBtn')}
                </Button>
                <UpgradePlanHint neededPlan={'basic'} position="end" placement="bottom" isOverlay />
              </div>
            :
              <Button size="small" color="primary" variant="contained" component={Link} to={`/apps/${item.slug}`} fullWidth>
                {t('partnerIntegrations.goToAppBtn')}
              </Button>
          )}
          {item.docsLink && (
            <Button size="small" color="primary" href={item.docsLink} target="_blank" fullWidth>
              {t('partnerIntegrations.documentationBtn')}
            </Button>
          )}
        </CardActions>
      </Card>
    );
  };

  render() {
    const { classes, t, partners, load_partners_pending } = this.props;

    const activeIntegartions = partners.filter(partner =>
      partner.partnerIntegration?.modules &&
      partner.partnerIntegration.integration !== null
    );

    const availableIntegrations = partners.filter(partner =>
      partner.partnerIntegration?.modules &&
      partner.partnerIntegration.integration === null
    );

    return (
      <React.Fragment>
        <LoadingIndicator pending={load_partners_pending} />

        <div className={'page-content'}>
          <Collapse in={activeIntegartions.length > 0} timeout="auto" unmountOnExit>
            <div>
              <Typography variant="h2" gutterBottom component="h2">
                {t('partnerIntegrations.activeIntegrations')}
              </Typography>
              <Divider className="divider-white" />
              <div className={classes.root}>
                <Grid
                  container
                  direction="row"
                  justifyContent="start"
                  alignItems="stretch"
                  spacing={10}
                  className={classes.gridRoot}
                >
                  {activeIntegartions.map((item, index) =>
                    this.renderPartnerCard(item, index, activeIntegartions)
                  )}
                </Grid>
              </div>
            </div>
          </Collapse>
          <Collapse in={availableIntegrations.length > 0} timeout="auto" unmountOnExit>
            <div>
              <Typography variant="h2" gutterBottom component="h2" className={activeIntegartions.length > 0 && classes.headline}>
                {t('partnerIntegrations.availableIntegrations')}
              </Typography>
              <Divider className={activeIntegartions.length === 0 && 'divider-white'} />
              <div className={classes.root}>
                <Grid
                  container
                  direction="row"
                  justifyContent="start"
                  alignItems="stretch"
                  spacing={10}
                  className={classes.gridRoot}
                >
                  {availableIntegrations.map((item, index) =>
                    this.renderPartnerCard(item, index, activeIntegartions)
                  )}
                </Grid>
              </div>
            </div>
          </Collapse>
          {partners.length > 0 &&
            <div style={{ marginTop: 60 }}>
              <Typography variant="h5" gutterBottom component="h5">
                {t('partnerIntegrations.exploreRecommendedApps')}
              </Typography>
              <Divider className="divider-white" />
              <div className={classes.root}>
                <Grid
                  container
                  direction="row"
                  justifyContent="start"
                  alignItems="stretch"
                  spacing={4}
                  className={classes.gridRoot}
                >
                  {partners
                    .filter(partner => !activeIntegartions.find(x => x.slug === partner.slug) && !availableIntegrations.find(x => x.slug === partner.slug))
                    .slice(0, 6)
                    .map((item, index) => (
                      <Grid key={`rec-${item.slug}`} size="auto">
                        <Card className={classes.compactCardRoot}>
                          {this.linkToListing(item,
                            <div className={classes.compactBanner}>
                              {this.renderLogo(item, classes.compactMediaLogo)}
                            </div>
                          )}
                          <CardContent className={classes.compactCardContent}>
                            <Typography variant="h6" component="h5" align="center" gutterBottom>
                              {item.title}
                            </Typography>
                            {item.subtitle && (
                              <Typography variant="caption" component="p" align="center" color="text.secondary" gutterBottom>
                                {item.subtitle}
                              </Typography>
                            )}
                            <Typography variant="body2" color="text.secondary" component="p" className={classes.compactDescription}>
                              {item.description}
                            </Typography>
                          </CardContent>
                          {item.partnerIntegration.modules && (
                            <PartnerIntegrationsSettings
                              partnerHandle={item.slug}
                              partnerData={item}
                              activeIntegration={null}
                              partnerIntegration={item.partnerIntegration.integration}
                            />
                          )}
                          {item.storeLink && (
                            <CardActions className={classes.cardActions}>
                              <Button size="small" color="primary" variant="contained" href={item.storeLink} target="_blank" fullWidth>
                                {t('partnerIntegrations.getAppBtn')}
                              </Button>
                            </CardActions>
                          )}
                        </Card>
                      </Grid>
                    ))}
                </Grid>
                <div style={{ textAlign: 'center', marginTop: 40 }}>
                  <Button
                    variant="outlined"
                    color="primary"
                    component={Link}
                    to="/recommended_apps"
                  >
                    {t('partnerIntegrations.viewAllApps')}
                  </Button>
                </div>
              </div>
            </div>            
          }
        </div>
      </React.Fragment>
    );
  }
}

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: 20,
    overflow: 'hidden',
    padding: 24,
  },
  gridRoot: {
    justifyContent: 'start',
  },
  headline: {
    fontSize: '1.75rem !important',
    marginTop: 40
  },
  cardRoot: {
    // dark mode: paper is darker than the ground since 661c3cc, an outline keeps the card visible
    ...(theme.palette.mode === 'dark' ? { border: `1px solid ${theme.palette.divider}` } : {}),
    maxWidth: 325,
    width: 325,
    margin: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    position: 'relative',
  },
  banner: {
    position: 'relative',
  },
  media: {
    height: 120,
    opacity: 1,
    borderBottom: 'solid 1px #eeeeee',
    overflow: 'hidden',
    '& img': {
      width: '100%',
      filter: 'contrast(200%) grayscale(50%) blur(4px) opacity(0.75)'
    }
  },
  mediaLogo: {
    width: 75,
    height: 75,
    position: 'absolute',
    display: 'inline-block',
    top: 60,
    left: 16,
    boxShadow: '2px -2px 10px 0px rgba(0,0,0,0.35)',
    border: 'solid 4px #fff',
    backgroundSize: 'contain'
  },
  cardContent: {
    height: '100%',
    marginTop: 10,
  },
  // stacked full-width buttons, the primary one first; MUI's inline gap between actions is reset
  cardActions: {
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: 4,
    padding: '8px 16px 12px',
    '& > :not(:first-of-type)': {
      marginLeft: 0,
    },
  },
  diffusor: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,.25)'
  },
  compactCardRoot: {
    // dark mode: paper is darker than the ground since 661c3cc, an outline keeps the card visible
    ...(theme.palette.mode === 'dark' ? { border: `1px solid ${theme.palette.divider}` } : {}),
    width: 280,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
  },
  compactBanner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '24px 16px 16px',
    borderBottom: 'solid 1px #eeeeee',
  },
  compactMediaLogo: {
    width: 60,
    height: 60,
    display: 'inline-block',
    boxShadow: '0px 2px 4px 0px rgba(0,0,0,0.15)',
    border: 'solid 2px #fff',
    backgroundSize: 'contain',
    borderRadius: 4,
  },
  compactCardContent: {
    padding: '16px !important',
    flex: 1,
  },
  compactDescription: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    fontSize: '0.875rem',
  }
});


const mapStateToProps = ({ shop, appIntegrations }) => ({
  editLanguage: shop.shop.edit_language,
  shopPlan: shop.shop.charge?.name,
  appIntegrations: appIntegrations,
  partners: appIntegrations.partners,
  load_partners_pending: appIntegrations.load_partners_pending
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadPartners,
    },
    dispatch
  )

const AppIntegrationsConnected = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(
    withStyles(styles)(withTranslation()(AppIntegrations))
  )
);

// Wrapper component to handle snackbar notifications
const AppIntegrationsWithSnackbar = (props) => {
  const { enqueueSnackbar } = useSnackbar();
  const activate_partner_integration_pending = useSelector(state => state.appIntegrations.activate_partner_integration_pending);
  const deactivate_partner_integration_pending = useSelector(state => state.appIntegrations.deactivate_partner_integration_pending);
  const partnerIntegration = useSelector(state => state.appIntegrations.partnerIntegration);
  const partnerIntegrationError = useSelector(state => state.appIntegrations.partnerIntegrationError);

  const prevActivatePending = useRef(activate_partner_integration_pending);
  const prevDeactivatePending = useRef(deactivate_partner_integration_pending);

  // Handle activation completion
  useEffect(() => {
    if (prevActivatePending.current && !activate_partner_integration_pending) {
      const wasSuccessful = partnerIntegration?.data?.enabled === true;
      if (!wasSuccessful && partnerIntegrationError) {
        enqueueSnackbar(partnerIntegrationError, {
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
          autoHideDuration: 6000,
        });
      } else if (wasSuccessful) {
        enqueueSnackbar('App integration has been activated successfully', {
          variant: 'success',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
          autoHideDuration: 3000,
        });
      }
    }
    prevActivatePending.current = activate_partner_integration_pending;
  }, [activate_partner_integration_pending, partnerIntegration, partnerIntegrationError, enqueueSnackbar]);

  // Handle deactivation completion
  useEffect(() => {
    if (prevDeactivatePending.current && !deactivate_partner_integration_pending) {
      const wasSuccessful = partnerIntegration === null;
      if (!wasSuccessful && partnerIntegrationError) {
        enqueueSnackbar(partnerIntegrationError, {
          variant: 'error',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
          autoHideDuration: 6000,
        });
      } else if (wasSuccessful) {
        enqueueSnackbar('App integration has been deactivated', {
          variant: 'info',
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
          },
          autoHideDuration: 3000,
        });
      }
    }
    prevDeactivatePending.current = deactivate_partner_integration_pending;
  }, [deactivate_partner_integration_pending, partnerIntegration, partnerIntegrationError, enqueueSnackbar]);

  return <AppIntegrationsConnected {...props} />;
};

export default AppIntegrationsWithSnackbar;




export const IntegratedAppsList = (props) => {
  let isAfterActiveElement = false;
  let partners = useSelector((state) => state.appIntegrations.partners);
  let partnersPending = useSelector((state) => state.appIntegrations.load_partners_pending);
  const shopPlan = useSelector((state) => state.shop.shop.charge?.name);
  const theme = useTheme();
  const dispatch = useDispatch();
  const pathParts = window.location.pathname.split('/').filter(Boolean);
  const appSlug = pathParts.length >= 2 && pathParts[0] === 'apps' ? pathParts[1] : pathParts.pop();

  useEffect(() => {
    if(partners.length === 0) {
      dispatch(loadPartners(() => {}));
    }
  }, []);

  useEffect(() => {
    
  }, [partners]);

  return <div>
      {partnersPending && partners.length === 0 ? 
        <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}>
          <CircularProgress size={20} />
        </div>
      :
      partners.map((partner, index) => {
        if (partner.partnerIntegration.integration !== null && partner.partnerIntegration.integration?.data?.enabled === true) {

          let isActive = (appSlug === partner.slug) ? true : false;
          if(index > partners.findIndex(p => p.slug === appSlug)) isAfterActiveElement = true;

          return <NavigationLink
            key={partner.slug}
            button
            {...props}
            to={`/apps/${partner.slug}`}
            selected={isActive}
            primary={partner.title}
            icon={
              // the same 8px to the title as the other rows' svg icons; no left margin - with one
              // the logo runs into the active-row arrow
              <span
                className={'app-link-icon'}
                style={{
                  width: 24,
                  height: 24,
                  flexShrink: 0,
                  marginRight: 8,
                  borderRadius: 6,
                  border: `1px solid ${theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.35)'}`,
                  backgroundSize: 'cover',
                  backgroundImage: `url(/files/images/recommendedApps/${partner.logo})`,
                  backgroundPosition: 'center'
                }}
              />
            }
            disabled={props.onboarding}
            locked={shopPlan === 'free' && PAID_PARTNER_SLUGS.includes(partner.slug)}
            neededPlan={'basic'}
            sx={{ pl: 4 }}
            isActive={isActive}
            isAfterActiveElement={isAfterActiveElement}
            size={'small'}
            dense
          />
        }
        else {
          return null
        }
      })}
  </div>
}
